"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFreeProducts = void 0;
const react_1 = require("react");
const navbar_1 = require("../context/navbar");
const helpers_1 = require("../helpers");
const types_1 = require("../types");
function isNonNull(value) {
    return value !== null;
}
const useFreeProducts = ({ showNonApplicableFreeProducts = true, }) => {
    const { coupons, cartItems, appliedCoupon } = (0, navbar_1.useNavbar)();
    const { total, totalItems, cartList } = (0, react_1.useMemo)(() => {
        const cartItemsList = cartItems.filter((item) => item.cartItemSource !== types_1.CartItemSource.COUPON);
        const cartTotal = (0, helpers_1.getTotalPrice)(cartItems);
        const { discount } = (0, helpers_1.getCouponDiscount)(appliedCoupon, cartItemsList);
        return {
            total: cartTotal - (discount !== null && discount !== void 0 ? discount : 0),
            totalItems: (0, helpers_1.getCartCount)(cartItemsList),
            cartList: cartItemsList,
        };
    }, [appliedCoupon, cartItems]);
    const freeProducts = (0, react_1.useMemo)(() => {
        const allFreeProducts = (coupons || [])
            .filter((coupon) => {
            const { couponType, applicableProducts, applicableCollections, minOrderValue, buyXQuantity, getYQuantity, isExternal, getYStoreProducts, } = coupon;
            if (couponType !== types_1.CouponType.FREEBIE)
                return false;
            if (isExternal)
                return false;
            if (!total)
                return false;
            if (!(getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.length))
                return false;
            if (showNonApplicableFreeProducts)
                return true;
            if (minOrderValue && minOrderValue > total)
                return false;
            if ((buyXQuantity !== null && buyXQuantity !== void 0 ? buyXQuantity : 1) + (getYQuantity !== null && getYQuantity !== void 0 ? getYQuantity : 1) > totalItems)
                return false;
            const hasProduct = Array.isArray(applicableProducts) && applicableProducts.length
                ? cartList.some((c) => applicableProducts.includes(c.id))
                : true;
            const hasCollection = Array.isArray(applicableCollections) && applicableCollections.length
                ? cartList.some((c) => applicableCollections.some((ac) => (c.collections || []).includes(ac)))
                : true;
            return hasCollection && hasProduct;
        })
            .map((coupon) => {
            var _a;
            const { applicableProducts, applicableCollections, minOrderValue, buyXQuantity, getYQuantity, getYStoreProducts, } = coupon;
            if (!(getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.length))
                return null;
            let allowed = true;
            if (minOrderValue && minOrderValue > total)
                allowed = false;
            if ((buyXQuantity !== null && buyXQuantity !== void 0 ? buyXQuantity : 1) + (getYQuantity !== null && getYQuantity !== void 0 ? getYQuantity : 1) > totalItems)
                allowed = false;
            const hasProduct = Array.isArray(applicableProducts) && applicableProducts.length
                ? cartList.some((c) => applicableProducts.includes(c.id))
                : true;
            const hasCollection = Array.isArray(applicableCollections) && applicableCollections.length
                ? cartList.some((c) => applicableCollections.some((ac) => (c.collections || []).includes(ac)))
                : true;
            allowed = allowed && hasCollection && hasProduct;
            const { message, discount } = (0, helpers_1.getCouponDiscount)(coupon, cartList);
            return {
                allowed,
                message,
                discount: discount !== null && discount !== void 0 ? discount : 0,
                products: (_a = getYStoreProducts === null || getYStoreProducts === void 0 ? void 0 : getYStoreProducts.filter(Boolean)) === null || _a === void 0 ? void 0 : _a.map((getYStoreProduct) => (Object.assign(Object.assign({}, getYStoreProduct), { thumbImage: (0, helpers_1.getThumbImage)(getYStoreProduct, null).imageKey }))),
            };
        });
        const nonNullFreeProducts = allFreeProducts.filter(isNonNull);
        const filteredFreeProducts = nonNullFreeProducts
            .sort((a, b) => (a.discount > b.discount ? 1 : -1))
            .sort((a) => (a.allowed ? -1 : 1));
        return filteredFreeProducts;
    }, [coupons, total, totalItems, cartList]);
    return freeProducts;
};
exports.useFreeProducts = useFreeProducts;
